export { PROFILE } from '@porotutu/react/api'

export const ORGANIZATIONS = ['organizations'] as const

export const USERS = ['users'] as const

export const AUDIT = ['audit'] as const

export const ROLES = ['roles'] as const
